import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import { Container, ContentWithPaddingXl } from "components/misc/Layouts";
import tw from "twin.macro";
import styled from "styled-components";
import { css } from "styled-components/macro"; //eslint-disable-line
import Footer from "salad/GrainFooter.js";
import { SectionHeading } from "components/misc/Headings";
import MobileHeaderOnly from "components/headers/light.js";

/* ===== 样式 ===== */
const HeaderWrap = styled.div`${tw`relative z-40`}`;
const PageBg = styled.div`
  ${tw`min-h-screen`};
  background-color: #fffbdc; /* 整页背景色 */
`;

const HeadingRow = tw.div`flex`;
const Heading = tw(SectionHeading)`text-gray-900 mb-10`;
const Text = styled.div`
  ${tw`text-lg text-gray-800`}
  p {
    ${tw`mt-2 leading-loose`}
  }
  h1 {
    ${tw`text-3xl font-bold mt-10`}
  }
  h2 {
    ${tw`text-2xl font-bold mt-8`}
  }
  h3 {
    ${tw`text-xl font-bold mt-6`}
  }
  ul {
    ${tw`list-disc list-inside`}
    li {
      ${tw`ml-2 mb-3`}
      p {
        ${tw`mt-0 inline leading-normal`}
      }
    }
  }
`;

export default ({ headingText = "GRAIN MEDITERRANEAN TERMS AND CONDITIONS" }) => {
  return (
      <>
        <PageBg>
          <HeaderWrap>
            <MobileHeaderOnly
                logoSrc="https://uk-grain.oss-eu-west-1.aliyuncs.com/grain-web/LOGO%20for%20website/Blue.svg"
                orderHref="https://order.grainmediterranean.com/"
            />
          </HeaderWrap>

          <AnimationRevealPage>
            <Container>
              <ContentWithPaddingXl>
                <HeadingRow>
                  <Heading>{headingText}</Heading>
                </HeadingRow>

                <Text>
                  {/* ================= Terms & Conditions ================= */}
                  <h1>Terms &amp; Conditions</h1>
                  <p><strong>Last updated:</strong> October 2025</p>
                  <p>
                    These Terms &amp; Conditions (“Terms”) set out the basis on which GBB Holborn Limited (trading as Grain Mediterranean, “we”,
                    “us”, “our”) provides services through our website, mobile application, and in-store. By using our services, you agree to be
                    bound by these Terms.
                  </p>

                  <h2>1. About Us</h2>
                  <p>
                    Grain Mediterranean is operated by GBB Holborn Limited, registered in England &amp; Wales (Company No. 15011782) with its
                    registered office at 10-14 Old Wallfields Pegs Lane, Hertford, Hertfordshire, United Kingdom, SG13 8EQ.
                    You can contact us at hello@grainmed.com.
                  </p>

                  <h2>2. Acceptance of Terms</h2>
                  <p>
                    By accessing our website, mobile application, or ordering in-store, you agree to comply with these Terms.
                    If you do not agree, you should not use our services.
                  </p>

                  <h2>3. Our Services</h2>
                  <p>
                    We provide food and beverage services, which may be ordered in-store or via our website and app. From time to time,
                    we may offer promotions, loyalty programmes, or gift cards, which are subject to these Terms.
                  </p>

                  <h2>4. Ordering &amp; Payment</h2>
                  <ul>
                    <li>Orders may be placed in-store or through our website/app.</li>
                    <li>Payment must be made in full at the time of ordering.</li>
                    <li>Prices include VAT where applicable.</li>
                    <li>Once placed, orders cannot usually be amended or cancelled. Refunds are at our discretion.</li>
                  </ul>

                  <h2>5. Delivery</h2>
                  <p>
                    If delivery is offered, we will use reasonable efforts to deliver on time but do not accept liability for delays caused by
                    circumstances beyond our control.
                  </p>

                  <h2>6. Dietary &amp; Allergen Information</h2>
                  <ul>
                    <li>We take food safety seriously and provide allergen information in-store and online.</li>
                    <li>Cross-contamination risks remain in any kitchen environment.</li>
                    <li>Customers with allergies or dietary needs must make these clear to our staff before ordering.</li>
                    <li>We cannot guarantee that any product is 100% allergen-free.</li>
                  </ul>

                  <h2>7. User Accounts</h2>
                  <p>
                    If you create an account on our website/app, you must keep login details secure. You are responsible for any activity under
                    your account.
                  </p>

                  <h2>8. User Content &amp; Reviews</h2>
                  <ul>
                    <li>
                      If you upload content (reviews, photos, comments), you grant us a royalty-free licence to use, reproduce, and share that
                      content for marketing or operational purposes.
                    </li>
                    <li>We may moderate and remove content that is unlawful, offensive, misleading, or inappropriate.</li>
                  </ul>

                  <h2>9. Loyalty &amp; Gift Cards</h2>
                  <ul>
                    <li>Loyalty rewards and gift cards are valid for 12 months from issue, unless otherwise stated.</li>
                    <li>They cannot be exchanged for cash.</li>
                    <li>Lost or stolen cards will not be replaced.</li>
                  </ul>

                  <h2>10. Intellectual Property</h2>
                  <p>
                    All rights in our brand, recipes, website, app, and other materials remain with Grain Mediterranean. You may not copy,
                    reproduce, or use them without permission.
                  </p>

                  <h2>11. Limitation of Liability</h2>
                  <ul>
                    <li>
                      <strong>For consumers:</strong> We are not liable for losses except those caused by our negligence or breach of statutory duty.
                      Your legal rights are not affected.
                    </li>
                    <li>
                      <strong>For businesses:</strong> Our liability is limited to the price paid for the relevant order. We do not accept liability
                      for indirect or consequential loss.
                    </li>
                  </ul>

                  <h2>12. Amendments</h2>
                  <p>
                    We may update these Terms from time to time. Material changes will be communicated through our website/app. Continued use of our
                    services constitutes acceptance of updated Terms.
                  </p>

                  <h2>13. Governing Law</h2>
                  <p>
                    These Terms are governed by the laws of England &amp; Wales. Any disputes will be subject to the exclusive jurisdiction of the
                    English courts.
                  </p>
                </Text>
              </ContentWithPaddingXl>
            </Container>
            <Footer />
          </AnimationRevealPage>
        </PageBg>
      </>
  );
};
